/* tslint:disable */
/* eslint-disable */
/**
 * Default
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {string}
   * @memberof InlineObject
   */
  redirectUri?: string;
}
/**
 *
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
  /**
   *
   * @type {string}
   * @memberof InlineObject1
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject1
   */
  password?: string;
}
/**
 *
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
  /**
   *
   * @type {number}
   * @memberof InlineObject10
   */
  rate?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject10
   */
  readyToTalk?: boolean;
}
/**
 *
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
  /**
   *
   * @type {object}
   * @memberof InlineObject11
   */
  setupIntent?: object;
}
/**
 *
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject12
   */
  added?: Array<number>;
}
/**
 *
 * @export
 * @interface InlineObject13
 */
export interface InlineObject13 {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject13
   */
  added?: Array<number>;
}
/**
 *
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
  /**
   * Токен подтверждения email
   * @type {string}
   * @memberof InlineObject14
   */
  token?: string;
}
/**
 *
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
  /**
   *
   * @type {string}
   * @memberof InlineObject15
   */
  service?: InlineObject15ServiceEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject15
   */
  deviceToken?: string;
  /**
   *
   * @type {object}
   * @memberof InlineObject15
   */
  customConfig?: object | null;
}

export const InlineObject15ServiceEnum = {
  Apns: 'apns',
  Fcm: 'fcm',
} as const;

export type InlineObject15ServiceEnum = typeof InlineObject15ServiceEnum[keyof typeof InlineObject15ServiceEnum];

/**
 *
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  password?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  description?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineObject16
   */
  avatarId?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject16
   */
  isFirstChallengeVisited?: boolean | null;
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject16
   */
  pinnedChatsIds?: Array<number> | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject16
   */
  isPaymentMethodAdditionSkipped?: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof InlineObject16
   */
  archivedChatsIds?: Array<number> | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject16
   */
  bio?: string | null;
  /**
   *
   * @type {ProfileNotifications}
   * @memberof InlineObject16
   */
  notifications?: ProfileNotifications | null;
}
/**
 *
 * @export
 * @interface InlineObject17
 */
export interface InlineObject17 {
  /**
   *
   * @type {string}
   * @memberof InlineObject17
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject17
   */
  redirect_uri?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject17
   */
  auth_uri?: string | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject17
   */
  metadata?: object | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject17
   */
  local_dev_token?: string | null;
}
/**
 *
 * @export
 * @interface InlineObject18
 */
export interface InlineObject18 {
  /**
   *
   * @type {string}
   * @memberof InlineObject18
   */
  os?: InlineObject18OsEnum;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject18
   */
  force?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineObject18
   */
  transactionId?: string;
}

export const InlineObject18OsEnum = {
  Ios: 'ios',
  Android: 'android',
} as const;

export type InlineObject18OsEnum = typeof InlineObject18OsEnum[keyof typeof InlineObject18OsEnum];

/**
 *
 * @export
 * @interface InlineObject19
 */
export interface InlineObject19 {
  /**
   *
   * @type {string}
   * @memberof InlineObject19
   */
  os?: InlineObject19OsEnum;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject19
   */
  force?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineObject19
   */
  transactionId?: string;
}

export const InlineObject19OsEnum = {
  Ios: 'ios',
  Android: 'android',
} as const;

export type InlineObject19OsEnum = typeof InlineObject19OsEnum[keyof typeof InlineObject19OsEnum];

/**
 *
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  redirect_uri?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  auth_uri?: string | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject2
   */
  metadata?: object | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  local_dev_token?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  email?: string;
}
/**
 *
 * @export
 * @interface InlineObject21
 */
export interface InlineObject21 {
  /**
   *
   * @type {string}
   * @memberof InlineObject21
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject21
   */
  type?: InlineObject21TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject21
   */
  mime?: string | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject21
   */
  meta?: object | null;
}

export const InlineObject21TypeEnum = {
  Audio: 'audio',
  Video: 'video',
  Image: 'image',
  Other: 'other',
} as const;

export type InlineObject21TypeEnum = typeof InlineObject21TypeEnum[keyof typeof InlineObject21TypeEnum];

/**
 *
 * @export
 * @interface InlineObject22
 */
export interface InlineObject22 {
  /**
   *
   * @type {number}
   * @memberof InlineObject22
   */
  frame?: number;
}
/**
 *
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
  /**
   *
   * @type {string}
   * @memberof InlineObject3
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject3
   */
  password?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject3
   */
  sendConfirmEmail?: boolean;
}
/**
 *
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
  /**
   *
   * @type {string}
   * @memberof InlineObject4
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject4
   */
  password?: string;
}
/**
 *
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
  /**
   * Цена (в центах!)
   * @type {number}
   * @memberof InlineObject5
   */
  price?: number;
}
/**
 *
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
  /**
   *
   * @type {Array<LinksOrderLinks>}
   * @memberof InlineObject6
   */
  links?: Array<LinksOrderLinks>;
}
/**
 *
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
  /**
   *
   * @type {string}
   * @memberof InlineObject7
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject7
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineObject7
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
  /**
   *
   * @type {string}
   * @memberof InlineObject8
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject8
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineObject8
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
  /**
   *
   * @type {string}
   * @memberof InlineObject9
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineObject9
   */
  type?: InlineObject9TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineObject9
   */
  mime?: string | null;
  /**
   *
   * @type {object}
   * @memberof InlineObject9
   */
  meta?: object | null;
}

export const InlineObject9TypeEnum = {
  Audio: 'audio',
  Video: 'video',
  Image: 'image',
  Other: 'other',
} as const;

export type InlineObject9TypeEnum = typeof InlineObject9TypeEnum[keyof typeof InlineObject9TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  authToken?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001
   */
  success?: string;
  /**
   *
   * @type {InlineResponse2001UserId}
   * @memberof InlineResponse2001
   */
  userId?: InlineResponse2001UserId;
}
/**
 *
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  created_at?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  price?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20010
   */
  inApp?: boolean;
  /**
   *
   * @type {MePurchasesSpace}
   * @memberof InlineResponse20010
   */
  space?: MePurchasesSpace | null;
}
/**
 *
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  lastPaymentDate?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  type?: InlineResponse20011TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  startedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  cancelledAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  price?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20011
   */
  isActive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20011
   */
  inApp?: boolean;
  /**
   *
   * @type {MeSubscriptionsSpace}
   * @memberof InlineResponse20011
   */
  space?: MeSubscriptionsSpace | null;
}

export const InlineResponse20011TypeEnum = {
  ForeverFree: 'foreverFree',
  FreeTrial: 'freeTrial',
  PaidTrial: 'paidTrial',
  FullPrice: 'fullPrice',
} as const;

export type InlineResponse20011TypeEnum = typeof InlineResponse20011TypeEnum[keyof typeof InlineResponse20011TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
  /**
   *
   * @type {InlineResponse20012File}
   * @memberof InlineResponse20012
   */
  file?: InlineResponse20012File;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  uploadUrl?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20012File
 */
export interface InlineResponse20012File {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012File
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012File
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012File
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012File
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012File
   */
  type?: InlineResponse20012FileTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012File
   */
  mime?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012File
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012File
   */
  originalUrl?: string | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20012File
   */
  meta?: object | null;
}

export const InlineResponse20012FileTypeEnum = {
  Audio: 'audio',
  Video: 'video',
  Image: 'image',
  Other: 'other',
} as const;

export type InlineResponse20012FileTypeEnum =
  typeof InlineResponse20012FileTypeEnum[keyof typeof InlineResponse20012FileTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20013
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20013
   */
  rate?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20013
   */
  readyToTalk?: boolean;
}
/**
 *
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20014
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20014
   */
  rate?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20014
   */
  readyToTalk?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20014
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20014
   */
  email?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  id?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineResponse20016
   */
  archivedChatsIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
  /**
   *
   * @type {Array<number>}
   * @memberof InlineResponse20017
   */
  pinnedChatsIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018
   */
  created_at?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018
   */
  bio?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018
   */
  isRegistrationCompleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018
   */
  gsCreated?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018
   */
  isFirstChallengeVisited?: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof InlineResponse20018
   */
  pinnedChatsIds?: Array<number> | null;
  /**
   *
   * @type {Array<number>}
   * @memberof InlineResponse20018
   */
  archivedChatsIds?: Array<number> | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018
   */
  isPaymentMethodAdditionSkipped?: boolean;
  /**
   *
   * @type {InlineResponse2002Notifications}
   * @memberof InlineResponse20018
   */
  notifications?: InlineResponse2002Notifications;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse20018
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse20019
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2001UserId
 */
export interface InlineResponse2001UserId {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001UserId
   */
  id?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  created_at?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isAdmin?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  bio?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isEmailConfirmed?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isRegistrationCompleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isFirstChallengeVisited?: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof InlineResponse2002
   */
  pinnedChatsIds?: Array<number> | null;
  /**
   *
   * @type {Array<number>}
   * @memberof InlineResponse2002
   */
  archivedChatsIds?: Array<number> | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isPaymentMethodAdditionSkipped?: boolean;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2002
   */
  gbFeatures?: object | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  gbUuid?: string | null;
  /**
   *
   * @type {InlineResponse2002Notifications}
   * @memberof InlineResponse2002
   */
  notifications?: InlineResponse2002Notifications;
  /**
   *
   * @type {InlineResponse2002PaymentMethod}
   * @memberof InlineResponse2002
   */
  paymentMethod?: InlineResponse2002PaymentMethod | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002
   */
  isExpert?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  slug?: string;
  /**
   *
   * @type {Array<InlineResponse2002Links>}
   * @memberof InlineResponse2002
   */
  links?: Array<InlineResponse2002Links>;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse2002
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
  /**
   *
   * @type {InlineResponse20020Space}
   * @memberof InlineResponse20020
   */
  space?: InlineResponse20020Space;
}
/**
 *
 * @export
 * @interface InlineResponse20020Space
 */
export interface InlineResponse20020Space {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020Space
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020Space
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020Space
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020Space
   */
  creatorPrice?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020Space
   */
  type?: InlineResponse20020SpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020Space
   */
  status?: InlineResponse20020SpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020Space
   */
  payment_type?: InlineResponse20020SpacePaymentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20020Space
   */
  priceModel?: InlineResponse20020SpacePriceModelEnum;
  /**
   *
   * @type {InlineResponse20020SpaceConfig}
   * @memberof InlineResponse20020Space
   */
  config?: InlineResponse20020SpaceConfig | null;
  /**
   *
   * @type {InlineResponse20020SpaceMarketingPriceConfig}
   * @memberof InlineResponse20020Space
   */
  marketingPriceConfig?: InlineResponse20020SpaceMarketingPriceConfig;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse20020Space
   */
  cover?: InlineResponse2002Avatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020Space
   */
  startAt?: number | null;
}

export const InlineResponse20020SpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse20020SpaceTypeEnum =
  typeof InlineResponse20020SpaceTypeEnum[keyof typeof InlineResponse20020SpaceTypeEnum];
export const InlineResponse20020SpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse20020SpaceStatusEnum =
  typeof InlineResponse20020SpaceStatusEnum[keyof typeof InlineResponse20020SpaceStatusEnum];
export const InlineResponse20020SpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20020SpacePaymentTypeEnum =
  typeof InlineResponse20020SpacePaymentTypeEnum[keyof typeof InlineResponse20020SpacePaymentTypeEnum];
export const InlineResponse20020SpacePriceModelEnum = {
  Fixed: 'fixed',
  Auction: 'auction',
} as const;

export type InlineResponse20020SpacePriceModelEnum =
  typeof InlineResponse20020SpacePriceModelEnum[keyof typeof InlineResponse20020SpacePriceModelEnum];

/**
 *
 * @export
 * @interface InlineResponse20020SpaceConfig
 */
export interface InlineResponse20020SpaceConfig {
  /**
   *
   * @type {InlineResponse20020SpaceConfigChallenge}
   * @memberof InlineResponse20020SpaceConfig
   */
  challenge?: InlineResponse20020SpaceConfigChallenge | null;
}
/**
 *
 * @export
 * @interface InlineResponse20020SpaceConfigChallenge
 */
export interface InlineResponse20020SpaceConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020SpaceConfigChallenge
   */
  finishTimestamp?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse20020SpaceMarketingPriceConfig
 */
export interface InlineResponse20020SpaceMarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020SpaceMarketingPriceConfig
   */
  previousPrice?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
  /**
   *
   * @type {InlineResponse20021Space}
   * @memberof InlineResponse20021
   */
  space?: InlineResponse20021Space;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021
   */
  clientSecret?: string;
  /**
   *
   * @type {InlineResponse20021Subscription}
   * @memberof InlineResponse20021
   */
  subscription?: InlineResponse20021Subscription;
}
/**
 *
 * @export
 * @interface InlineResponse20021Space
 */
export interface InlineResponse20021Space {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Space
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Space
   */
  expert?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Space
   */
  club?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Space
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Space
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Space
   */
  type?: InlineResponse20021SpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Space
   */
  status?: InlineResponse20021SpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Space
   */
  payment_type?: InlineResponse20021SpacePaymentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Space
   */
  trialPrice?: number;
}

export const InlineResponse20021SpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse20021SpaceTypeEnum =
  typeof InlineResponse20021SpaceTypeEnum[keyof typeof InlineResponse20021SpaceTypeEnum];
export const InlineResponse20021SpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse20021SpaceStatusEnum =
  typeof InlineResponse20021SpaceStatusEnum[keyof typeof InlineResponse20021SpaceStatusEnum];
export const InlineResponse20021SpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20021SpacePaymentTypeEnum =
  typeof InlineResponse20021SpacePaymentTypeEnum[keyof typeof InlineResponse20021SpacePaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20021Subscription
 */
export interface InlineResponse20021Subscription {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  lastPaymentDate?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Subscription
   */
  type?: InlineResponse20021SubscriptionTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  startedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  cancelledAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  price?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20021Subscription
   */
  isActive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20021Subscription
   */
  inApp?: boolean;
}

export const InlineResponse20021SubscriptionTypeEnum = {
  ForeverFree: 'foreverFree',
  FreeTrial: 'freeTrial',
  PaidTrial: 'paidTrial',
  FullPrice: 'fullPrice',
} as const;

export type InlineResponse20021SubscriptionTypeEnum =
  typeof InlineResponse20021SubscriptionTypeEnum[keyof typeof InlineResponse20021SubscriptionTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20022
 */
export interface InlineResponse20022 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  lastPaymentDate?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20022
   */
  type?: InlineResponse20022TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  startedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  cancelledAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  price?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20022
   */
  isActive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20022
   */
  inApp?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20022
   */
  nextPaymentDate?: number | null;
}

export const InlineResponse20022TypeEnum = {
  ForeverFree: 'foreverFree',
  FreeTrial: 'freeTrial',
  PaidTrial: 'paidTrial',
  FullPrice: 'fullPrice',
} as const;

export type InlineResponse20022TypeEnum = typeof InlineResponse20022TypeEnum[keyof typeof InlineResponse20022TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20023
 */
export interface InlineResponse20023 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  path?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  type?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20023
   */
  size?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20023
   */
  mime?: string;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20023
   */
  meta?: object;
}
/**
 *
 * @export
 * @interface InlineResponse20024
 */
export interface InlineResponse20024 {
  /**
   *
   * @type {InlineResponse20024File}
   * @memberof InlineResponse20024
   */
  file?: InlineResponse20024File;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024
   */
  uploadUrl?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20024File
 */
export interface InlineResponse20024File {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20024File
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20024File
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20024File
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024File
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024File
   */
  type?: InlineResponse20024FileTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024File
   */
  mime?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024File
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024File
   */
  originalUrl?: string | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20024File
   */
  meta?: object | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20024File
   */
  previewUrl?: string | null;
}

export const InlineResponse20024FileTypeEnum = {
  Audio: 'audio',
  Video: 'video',
  Image: 'image',
  Other: 'other',
} as const;

export type InlineResponse20024FileTypeEnum =
  typeof InlineResponse20024FileTypeEnum[keyof typeof InlineResponse20024FileTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2002Avatar
 */
export interface InlineResponse2002Avatar {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002Avatar
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002Avatar
   */
  url?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2002Links
 */
export interface InlineResponse2002Links {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002Links
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002Links
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002Links
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002Links
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2002Notifications
 */
export interface InlineResponse2002Notifications {
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Notifications
   */
  newMessagesInChallenges?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Notifications
   */
  newMentionsInChallenges?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Notifications
   */
  newCreatorsMessagesInChallenges?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Notifications
   */
  newMessagesInDMs?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Notifications
   */
  newPlatformMessages?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Notifications
   */
  newRepliesInChallenges?: boolean;
}
/**
 *
 * @export
 * @interface InlineResponse2002PaymentMethod
 */
export interface InlineResponse2002PaymentMethod {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002PaymentMethod
   */
  id?: string;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2002PaymentMethod
   */
  card?: object;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002PaymentMethod
   */
  type?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {InlineResponse2003Creator}
   * @memberof InlineResponse2003
   */
  creator?: InlineResponse2003Creator;
}
/**
 *
 * @export
 * @interface InlineResponse2003Creator
 */
export interface InlineResponse2003Creator {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003Creator
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003Creator
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003Creator
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2003Creator
   */
  isAvatar?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003Creator
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {InlineResponse2003CreatorClub}
   * @memberof InlineResponse2003Creator
   */
  club?: InlineResponse2003CreatorClub | null;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse2003Creator
   */
  avatar?: InlineResponse2002Avatar | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003Creator
   */
  slug?: string;
  /**
   *
   * @type {Array<InlineResponse2002Links>}
   * @memberof InlineResponse2003Creator
   */
  links?: Array<InlineResponse2002Links>;
}
/**
 *
 * @export
 * @interface InlineResponse2003CreatorClub
 */
export interface InlineResponse2003CreatorClub {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003CreatorClub
   */
  id?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  subscribed_at?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isAvatar?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  customerId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  slug?: string;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse2004
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  price?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
  /**
   *
   * @type {Array<InlineResponse2008Subscriptions>}
   * @memberof InlineResponse2008
   */
  subscriptions?: Array<InlineResponse2008Subscriptions>;
  /**
   *
   * @type {Array<InlineResponse2008Purchases>}
   * @memberof InlineResponse2008
   */
  purchases?: Array<InlineResponse2008Purchases>;
}
/**
 *
 * @export
 * @interface InlineResponse2008Purchases
 */
export interface InlineResponse2008Purchases {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008Purchases
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008Purchases
   */
  name?: string;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse2008Purchases
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2008Subscriptions
 */
export interface InlineResponse2008Subscriptions {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008Subscriptions
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008Subscriptions
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2008Subscriptions
   */
  isAvatar?: boolean;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof InlineResponse2008Subscriptions
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  points?: number;
  /**
   *
   * @type {MePointsTag}
   * @memberof InlineResponse2009
   */
  tag?: MePointsTag | null;
}
/**
 *
 * @export
 * @interface LinksOrderLinks
 */
export interface LinksOrderLinks {
  /**
   *
   * @type {number}
   * @memberof LinksOrderLinks
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof LinksOrderLinks
   */
  order?: number;
}
/**
 *
 * @export
 * @interface MePointsTag
 */
export interface MePointsTag {
  /**
   *
   * @type {number}
   * @memberof MePointsTag
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MePointsTag
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof MePointsTag
   */
  color?: string;
}
/**
 *
 * @export
 * @interface MePurchasesSpace
 */
export interface MePurchasesSpace {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpace
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  type?: MePurchasesSpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  status?: MePurchasesSpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  payment_type?: MePurchasesSpacePaymentTypeEnum;
  /**
   *
   * @type {MePurchasesSpaceConfig}
   * @memberof MePurchasesSpace
   */
  config?: MePurchasesSpaceConfig | null;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpace
   */
  userSlug?: string | null;
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpace
   */
  chatId?: number | null;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof MePurchasesSpace
   */
  cover?: InlineResponse2002Avatar | null;
  /**
   *
   * @type {MePurchasesSpaceExpert}
   * @memberof MePurchasesSpace
   */
  expert?: MePurchasesSpaceExpert | null;
  /**
   *
   * @type {MePurchasesSpaceFirstStep}
   * @memberof MePurchasesSpace
   */
  firstStep?: MePurchasesSpaceFirstStep | null;
}

export const MePurchasesSpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type MePurchasesSpaceTypeEnum = typeof MePurchasesSpaceTypeEnum[keyof typeof MePurchasesSpaceTypeEnum];
export const MePurchasesSpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type MePurchasesSpaceStatusEnum = typeof MePurchasesSpaceStatusEnum[keyof typeof MePurchasesSpaceStatusEnum];
export const MePurchasesSpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type MePurchasesSpacePaymentTypeEnum =
  typeof MePurchasesSpacePaymentTypeEnum[keyof typeof MePurchasesSpacePaymentTypeEnum];

/**
 *
 * @export
 * @interface MePurchasesSpaceConfig
 */
export interface MePurchasesSpaceConfig {
  /**
   *
   * @type {MePurchasesSpaceConfigLive}
   * @memberof MePurchasesSpaceConfig
   */
  live?: MePurchasesSpaceConfigLive | null;
}
/**
 *
 * @export
 * @interface MePurchasesSpaceConfigLive
 */
export interface MePurchasesSpaceConfigLive {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceConfigLive
   */
  duration?: number;
  /**
   *
   * @type {MePurchasesSpaceConfigLiveRecord}
   * @memberof MePurchasesSpaceConfigLive
   */
  record?: MePurchasesSpaceConfigLiveRecord | null;
}
/**
 *
 * @export
 * @interface MePurchasesSpaceConfigLiveRecord
 */
export interface MePurchasesSpaceConfigLiveRecord {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceConfigLiveRecord
   */
  videoFileId?: number;
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceConfigLiveRecord
   */
  coverFileId?: number | null;
  /**
   *
   * @type {object}
   * @memberof MePurchasesSpaceConfigLiveRecord
   */
  meta?: object | null;
}
/**
 *
 * @export
 * @interface MePurchasesSpaceExpert
 */
export interface MePurchasesSpaceExpert {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceExpert
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MePurchasesSpaceExpert
   */
  name?: string;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof MePurchasesSpaceExpert
   */
  avatar?: InlineResponse2002Avatar | null;
}
/**
 *
 * @export
 * @interface MePurchasesSpaceFirstStep
 */
export interface MePurchasesSpaceFirstStep {
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceFirstStep
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof MePurchasesSpaceFirstStep
   */
  startAt?: number | null;
}
/**
 *
 * @export
 * @interface MeSubscriptionsSpace
 */
export interface MeSubscriptionsSpace {
  /**
   *
   * @type {number}
   * @memberof MeSubscriptionsSpace
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MeSubscriptionsSpace
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof MeSubscriptionsSpace
   */
  type?: MeSubscriptionsSpaceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof MeSubscriptionsSpace
   */
  status?: MeSubscriptionsSpaceStatusEnum;
  /**
   *
   * @type {string}
   * @memberof MeSubscriptionsSpace
   */
  payment_type?: MeSubscriptionsSpacePaymentTypeEnum;
  /**
   *
   * @type {InlineResponse2002Avatar}
   * @memberof MeSubscriptionsSpace
   */
  cover?: InlineResponse2002Avatar | null;
  /**
   *
   * @type {string}
   * @memberof MeSubscriptionsSpace
   */
  userSlug?: string | null;
}

export const MeSubscriptionsSpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type MeSubscriptionsSpaceTypeEnum =
  typeof MeSubscriptionsSpaceTypeEnum[keyof typeof MeSubscriptionsSpaceTypeEnum];
export const MeSubscriptionsSpaceStatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type MeSubscriptionsSpaceStatusEnum =
  typeof MeSubscriptionsSpaceStatusEnum[keyof typeof MeSubscriptionsSpaceStatusEnum];
export const MeSubscriptionsSpacePaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type MeSubscriptionsSpacePaymentTypeEnum =
  typeof MeSubscriptionsSpacePaymentTypeEnum[keyof typeof MeSubscriptionsSpacePaymentTypeEnum];

/**
 *
 * @export
 * @interface ProfileNotifications
 */
export interface ProfileNotifications {
  /**
   *
   * @type {boolean}
   * @memberof ProfileNotifications
   */
  newMessagesInChallenges?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProfileNotifications
   */
  newMentionsInChallenges?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProfileNotifications
   */
  newCreatorsMessagesInChallenges?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProfileNotifications
   */
  newMessagesInDMs?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProfileNotifications
   */
  newPlatformMessages?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProfileNotifications
   */
  newRepliesInChallenges?: boolean;
}

/**
 * AndroidApi - axios parameter creator
 * @export
 */
export const AndroidApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [message]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    androidPushDmGet: async (
      deviceToken: string,
      message?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceToken' is not null or undefined
      assertParamExists('androidPushDmGet', 'deviceToken', deviceToken);
      const localVarPath = `/android/push/dm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (deviceToken !== undefined) {
        localVarQueryParameter['deviceToken'] = deviceToken;
      }

      if (message !== undefined) {
        localVarQueryParameter['message'] = message;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    androidPushGet: async (
      deviceToken: string,
      url?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceToken' is not null or undefined
      assertParamExists('androidPushGet', 'deviceToken', deviceToken);
      const localVarPath = `/android/push`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (deviceToken !== undefined) {
        localVarQueryParameter['deviceToken'] = deviceToken;
      }

      if (url !== undefined) {
        localVarQueryParameter['url'] = url;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AndroidApi - functional programming interface
 * @export
 */
export const AndroidApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AndroidApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [message]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async androidPushDmGet(
      deviceToken: string,
      message?: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.androidPushDmGet(deviceToken, message, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async androidPushGet(
      deviceToken: string,
      url?: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.androidPushGet(deviceToken, url, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * AndroidApi - factory interface
 * @export
 */
export const AndroidApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AndroidApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [message]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    androidPushDmGet(deviceToken: string, message?: string, options?: any): AxiosPromise<object> {
      return localVarFp.androidPushDmGet(deviceToken, message, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    androidPushGet(deviceToken: string, url?: string, options?: any): AxiosPromise<object> {
      return localVarFp.androidPushGet(deviceToken, url, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * AndroidApi - object-oriented interface
 * @export
 * @class AndroidApi
 * @extends {BaseAPI}
 */
export class AndroidApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> not required
   * @param {string} deviceToken
   * @param {string} [message]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AndroidApi
   */
  public androidPushDmGet(deviceToken: string, message?: string, options?: AxiosRequestConfig) {
    return AndroidApiFp(this.configuration)
      .androidPushDmGet(deviceToken, message, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> not required
   * @param {string} deviceToken
   * @param {string} [url]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AndroidApi
   */
  public androidPushGet(deviceToken: string, url?: string, options?: AxiosRequestConfig) {
    return AndroidApiFp(this.configuration)
      .androidPushGet(deviceToken, url, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCodePost: async (inlineObject?: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/code`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Login and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Login and retrieve an authentication token
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLoginPost: async (inlineObject1?: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMagicKeyPost: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists('authMagicKeyPost', 'key', key);
      const localVarPath = `/auth/magic/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Аутентификация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация через \"магическую\" ссылку на почту
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMagicPost: async (inlineObject2?: InlineObject2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/magic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get the user record belonging to the authentication token <br /><br /> <b>Authentication:</b> required
     * @summary Get the user record belonging to the authentication token
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMeGet: async (force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (force !== undefined) {
        localVarQueryParameter['force'] = force;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Запрос письма на подтверждение электронной почты <br /><br /> <b>Authentication:</b> required
     * @summary Запрос письма на подтверждение электронной почты
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRequestConfirmEmailPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/requestConfirmEmail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Signup and retrieve an authentication token
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSignupPost: async (inlineObject3?: InlineObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/signup`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authCodePost(
      inlineObject?: InlineObject,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authCodePost(inlineObject, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Login and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Login and retrieve an authentication token
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authLoginPost(
      inlineObject1?: InlineObject1,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginPost(inlineObject1, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMagicKeyPost(
      key: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authMagicKeyPost(key, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Аутентификация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация через \"магическую\" ссылку на почту
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMagicPost(
      inlineObject2?: InlineObject2,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authMagicPost(inlineObject2, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Get the user record belonging to the authentication token <br /><br /> <b>Authentication:</b> required
     * @summary Get the user record belonging to the authentication token
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMeGet(
      force?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authMeGet(force, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Запрос письма на подтверждение электронной почты <br /><br /> <b>Authentication:</b> required
     * @summary Запрос письма на подтверждение электронной почты
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authRequestConfirmEmailPost(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authRequestConfirmEmailPost(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Signup and retrieve an authentication token
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authSignupPost(
      inlineObject3?: InlineObject3,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authSignupPost(inlineObject3, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AuthApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authCodePost(inlineObject?: InlineObject, options?: any): AxiosPromise<object> {
      return localVarFp.authCodePost(inlineObject, options).then(request => request(axios, basePath));
    },
    /**
     * Login and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Login and retrieve an authentication token
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLoginPost(inlineObject1?: InlineObject1, options?: any): AxiosPromise<InlineResponse200> {
      return localVarFp.authLoginPost(inlineObject1, options).then(request => request(axios, basePath));
    },
    /**
     * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMagicKeyPost(key: string, options?: any): AxiosPromise<object> {
      return localVarFp.authMagicKeyPost(key, options).then(request => request(axios, basePath));
    },
    /**
     * Аутентификация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация через \"магическую\" ссылку на почту
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMagicPost(inlineObject2?: InlineObject2, options?: any): AxiosPromise<InlineResponse2001> {
      return localVarFp.authMagicPost(inlineObject2, options).then(request => request(axios, basePath));
    },
    /**
     * Get the user record belonging to the authentication token <br /><br /> <b>Authentication:</b> required
     * @summary Get the user record belonging to the authentication token
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMeGet(force?: boolean, options?: any): AxiosPromise<InlineResponse2002> {
      return localVarFp.authMeGet(force, options).then(request => request(axios, basePath));
    },
    /**
     * Запрос письма на подтверждение электронной почты <br /><br /> <b>Authentication:</b> required
     * @summary Запрос письма на подтверждение электронной почты
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRequestConfirmEmailPost(options?: any): AxiosPromise<object> {
      return localVarFp.authRequestConfirmEmailPost(options).then(request => request(axios, basePath));
    },
    /**
     * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Signup and retrieve an authentication token
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSignupPost(inlineObject3?: InlineObject3, options?: any): AxiosPromise<InlineResponse200> {
      return localVarFp.authSignupPost(inlineObject3, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authCodePost(inlineObject?: InlineObject, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authCodePost(inlineObject, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Login and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
   * @summary Login and retrieve an authentication token
   * @param {InlineObject1} [inlineObject1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authLoginPost(inlineObject1?: InlineObject1, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authLoginPost(inlineObject1, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
   * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
   * @param {string} key
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authMagicKeyPost(key: string, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authMagicKeyPost(key, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Аутентификация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
   * @summary Аутентификация через \"магическую\" ссылку на почту
   * @param {InlineObject2} [inlineObject2]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authMagicPost(inlineObject2?: InlineObject2, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authMagicPost(inlineObject2, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get the user record belonging to the authentication token <br /><br /> <b>Authentication:</b> required
   * @summary Get the user record belonging to the authentication token
   * @param {boolean} [force]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authMeGet(force?: boolean, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authMeGet(force, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Запрос письма на подтверждение электронной почты <br /><br /> <b>Authentication:</b> required
   * @summary Запрос письма на подтверждение электронной почты
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authRequestConfirmEmailPost(options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authRequestConfirmEmailPost(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
   * @summary Signup and retrieve an authentication token
   * @param {InlineObject3} [inlineObject3]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authSignupPost(inlineObject3?: InlineObject3, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authSignupPost(inlineObject3, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CreatorsApi - axios parameter creator
 * @export
 */
export const CreatorsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdSubscribePost: async (
      creatorId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdSubscribePost', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}/subscribe`.replace(
        `{${'creatorId'}}`,
        encodeURIComponent(String(creatorId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CreatorsApi - functional programming interface
 * @export
 */
export const CreatorsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CreatorsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdSubscribePost(
      creatorId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdSubscribePost(creatorId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CreatorsApi - factory interface
 * @export
 */
export const CreatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CreatorsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdSubscribePost(creatorId: number, options?: any): AxiosPromise<InlineResponse2003> {
      return localVarFp.creatorsCreatorIdSubscribePost(creatorId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * CreatorsApi - object-oriented interface
 * @export
 * @class CreatorsApi
 * @extends {BaseAPI}
 */
export class CreatorsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdSubscribePost(creatorId: number, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdSubscribePost(creatorId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ExpertApi - axios parameter creator
 * @export
 */
export const ExpertApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Signup and retrieve an authentication token
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertAuthSignupPost: async (
      inlineObject4?: InlineObject4,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/expert/auth/signup`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Получение списка подписчиков <br /><br /> <b>Authentication:</b> required
     * @summary Получение списка подписчиков
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertMembersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/expert/members`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Настройка цены <br /><br /> <b>Authentication:</b> required
     * @summary Настройка цены
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertPricePost: async (inlineObject5?: InlineObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/expert/price`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExpertApi - functional programming interface
 * @export
 */
export const ExpertApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExpertApiAxiosParamCreator(configuration);
  return {
    /**
     * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Signup and retrieve an authentication token
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertAuthSignupPost(
      inlineObject4?: InlineObject4,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertAuthSignupPost(inlineObject4, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Получение списка подписчиков <br /><br /> <b>Authentication:</b> required
     * @summary Получение списка подписчиков
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertMembersGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2004>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertMembersGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Настройка цены <br /><br /> <b>Authentication:</b> required
     * @summary Настройка цены
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertPricePost(
      inlineObject5?: InlineObject5,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertPricePost(inlineObject5, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ExpertApi - factory interface
 * @export
 */
export const ExpertApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ExpertApiFp(configuration);
  return {
    /**
     * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
     * @summary Signup and retrieve an authentication token
     * @param {InlineObject4} [inlineObject4]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertAuthSignupPost(inlineObject4?: InlineObject4, options?: any): AxiosPromise<InlineResponse200> {
      return localVarFp.expertAuthSignupPost(inlineObject4, options).then(request => request(axios, basePath));
    },
    /**
     * Получение списка подписчиков <br /><br /> <b>Authentication:</b> required
     * @summary Получение списка подписчиков
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertMembersGet(options?: any): AxiosPromise<Array<InlineResponse2004>> {
      return localVarFp.expertMembersGet(options).then(request => request(axios, basePath));
    },
    /**
     * Настройка цены <br /><br /> <b>Authentication:</b> required
     * @summary Настройка цены
     * @param {InlineObject5} [inlineObject5]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertPricePost(inlineObject5?: InlineObject5, options?: any): AxiosPromise<InlineResponse2005> {
      return localVarFp.expertPricePost(inlineObject5, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ExpertApi - object-oriented interface
 * @export
 * @class ExpertApi
 * @extends {BaseAPI}
 */
export class ExpertApi extends BaseAPI {
  /**
   * Signup and retrieve an authentication token <br /><br /> <b>Authentication:</b> not required
   * @summary Signup and retrieve an authentication token
   * @param {InlineObject4} [inlineObject4]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpertApi
   */
  public expertAuthSignupPost(inlineObject4?: InlineObject4, options?: AxiosRequestConfig) {
    return ExpertApiFp(this.configuration)
      .expertAuthSignupPost(inlineObject4, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Получение списка подписчиков <br /><br /> <b>Authentication:</b> required
   * @summary Получение списка подписчиков
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpertApi
   */
  public expertMembersGet(options?: AxiosRequestConfig) {
    return ExpertApiFp(this.configuration)
      .expertMembersGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Настройка цены <br /><br /> <b>Authentication:</b> required
   * @summary Настройка цены
   * @param {InlineObject5} [inlineObject5]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpertApi
   */
  public expertPricePost(inlineObject5?: InlineObject5, options?: AxiosRequestConfig) {
    return ExpertApiFp(this.configuration)
      .expertPricePost(inlineObject5, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * IosApi - axios parameter creator
 * @export
 */
export const IosApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [message]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iosPushDmGet: async (
      deviceToken: string,
      message?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'deviceToken' is not null or undefined
      assertParamExists('iosPushDmGet', 'deviceToken', deviceToken);
      const localVarPath = `/ios/push/dm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (deviceToken !== undefined) {
        localVarQueryParameter['deviceToken'] = deviceToken;
      }

      if (message !== undefined) {
        localVarQueryParameter['message'] = message;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * IosApi - functional programming interface
 * @export
 */
export const IosApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IosApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [message]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async iosPushDmGet(
      deviceToken: string,
      message?: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.iosPushDmGet(deviceToken, message, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * IosApi - factory interface
 * @export
 */
export const IosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = IosApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {string} deviceToken
     * @param {string} [message]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    iosPushDmGet(deviceToken: string, message?: string, options?: any): AxiosPromise<object> {
      return localVarFp.iosPushDmGet(deviceToken, message, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * IosApi - object-oriented interface
 * @export
 * @class IosApi
 * @extends {BaseAPI}
 */
export class IosApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> not required
   * @param {string} deviceToken
   * @param {string} [message]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IosApi
   */
  public iosPushDmGet(deviceToken: string, message?: string, options?: AxiosRequestConfig) {
    return IosApiFp(this.configuration)
      .iosPushDmGet(deviceToken, message, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * LinksApi - axios parameter creator
 * @export
 */
export const LinksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/links`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksLinkIdDelete: async (linkId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('linksLinkIdDelete', 'linkId', linkId);
      const localVarPath = `/links/{linkId}`.replace(`{${'linkId'}}`, encodeURIComponent(String(linkId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksLinkIdPost: async (
      linkId: number,
      inlineObject7?: InlineObject7,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('linksLinkIdPost', 'linkId', linkId);
      const localVarPath = `/links/{linkId}`.replace(`{${'linkId'}}`, encodeURIComponent(String(linkId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject7, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksOrderPatch: async (inlineObject6?: InlineObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/links/order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject6, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject8} [inlineObject8]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksPost: async (inlineObject8?: InlineObject8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/links`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject8, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LinksApi - functional programming interface
 * @export
 */
export const LinksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LinksApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linksGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2006>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.linksGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linksLinkIdDelete(
      linkId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.linksLinkIdDelete(linkId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linksLinkIdPost(
      linkId: number,
      inlineObject7?: InlineObject7,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.linksLinkIdPost(linkId, inlineObject7, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linksOrderPatch(
      inlineObject6?: InlineObject6,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.linksOrderPatch(inlineObject6, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject8} [inlineObject8]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async linksPost(
      inlineObject8?: InlineObject8,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2007>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.linksPost(inlineObject8, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * LinksApi - factory interface
 * @export
 */
export const LinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = LinksApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksGet(options?: any): AxiosPromise<Array<InlineResponse2006>> {
      return localVarFp.linksGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksLinkIdDelete(linkId: number, options?: any): AxiosPromise<object> {
      return localVarFp.linksLinkIdDelete(linkId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} linkId
     * @param {InlineObject7} [inlineObject7]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksLinkIdPost(linkId: number, inlineObject7?: InlineObject7, options?: any): AxiosPromise<InlineResponse2006> {
      return localVarFp.linksLinkIdPost(linkId, inlineObject7, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject6} [inlineObject6]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksOrderPatch(inlineObject6?: InlineObject6, options?: any): AxiosPromise<object> {
      return localVarFp.linksOrderPatch(inlineObject6, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject8} [inlineObject8]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linksPost(inlineObject8?: InlineObject8, options?: any): AxiosPromise<InlineResponse2007> {
      return localVarFp.linksPost(inlineObject8, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * LinksApi - object-oriented interface
 * @export
 * @class LinksApi
 * @extends {BaseAPI}
 */
export class LinksApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LinksApi
   */
  public linksGet(options?: AxiosRequestConfig) {
    return LinksApiFp(this.configuration)
      .linksGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} linkId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LinksApi
   */
  public linksLinkIdDelete(linkId: number, options?: AxiosRequestConfig) {
    return LinksApiFp(this.configuration)
      .linksLinkIdDelete(linkId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} linkId
   * @param {InlineObject7} [inlineObject7]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LinksApi
   */
  public linksLinkIdPost(linkId: number, inlineObject7?: InlineObject7, options?: AxiosRequestConfig) {
    return LinksApiFp(this.configuration)
      .linksLinkIdPost(linkId, inlineObject7, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject6} [inlineObject6]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LinksApi
   */
  public linksOrderPatch(inlineObject6?: InlineObject6, options?: AxiosRequestConfig) {
    return LinksApiFp(this.configuration)
      .linksOrderPatch(inlineObject6, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject8} [inlineObject8]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LinksApi
   */
  public linksPost(inlineObject8?: InlineObject8, options?: AxiosRequestConfig) {
    return LinksApiFp(this.configuration)
      .linksPost(inlineObject8, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Преобразование кастомера в эксперта <br /><br /> <b>Authentication:</b> required
     * @summary Преобразование кастомера в эксперта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meBecomeAnExpertPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/becomeAnExpert`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meCreatorsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/creators`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePointsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/points`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePurchasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/purchases`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meSubscriptionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/subscriptions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration);
  return {
    /**
     * Преобразование кастомера в эксперта <br /><br /> <b>Authentication:</b> required
     * @summary Преобразование кастомера в эксперта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meBecomeAnExpertPost(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meBecomeAnExpertPost(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meCreatorsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2008>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meCreatorsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePointsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2009>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePointsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePurchasesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20010>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePurchasesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meSubscriptionsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20011>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meSubscriptionsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = MeApiFp(configuration);
  return {
    /**
     * Преобразование кастомера в эксперта <br /><br /> <b>Authentication:</b> required
     * @summary Преобразование кастомера в эксперта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meBecomeAnExpertPost(options?: any): AxiosPromise<object> {
      return localVarFp.meBecomeAnExpertPost(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meCreatorsGet(options?: any): AxiosPromise<InlineResponse2008> {
      return localVarFp.meCreatorsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePointsGet(options?: any): AxiosPromise<Array<InlineResponse2009>> {
      return localVarFp.mePointsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePurchasesGet(options?: any): AxiosPromise<Array<InlineResponse20010>> {
      return localVarFp.mePurchasesGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meSubscriptionsGet(options?: any): AxiosPromise<Array<InlineResponse20011>> {
      return localVarFp.meSubscriptionsGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
  /**
   * Преобразование кастомера в эксперта <br /><br /> <b>Authentication:</b> required
   * @summary Преобразование кастомера в эксперта
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meBecomeAnExpertPost(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meBecomeAnExpertPost(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meCreatorsGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meCreatorsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public mePointsGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .mePointsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public mePurchasesGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .mePurchasesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeApi
   */
  public meSubscriptionsGet(options?: AxiosRequestConfig) {
    return MeApiFp(this.configuration)
      .meSubscriptionsGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MobileApi - axios parameter creator
 * @export
 */
export const MobileApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {InlineObject9} [inlineObject9]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileUploadUrlPost: async (
      inlineObject9?: InlineObject9,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/mobile/upload/url`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject9, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MobileApi - functional programming interface
 * @export
 */
export const MobileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MobileApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {InlineObject9} [inlineObject9]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mobileUploadUrlPost(
      inlineObject9?: InlineObject9,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mobileUploadUrlPost(inlineObject9, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * MobileApi - factory interface
 * @export
 */
export const MobileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = MobileApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> not required
     * @param {InlineObject9} [inlineObject9]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mobileUploadUrlPost(inlineObject9?: InlineObject9, options?: any): AxiosPromise<InlineResponse20012> {
      return localVarFp.mobileUploadUrlPost(inlineObject9, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * MobileApi - object-oriented interface
 * @export
 * @class MobileApi
 * @extends {BaseAPI}
 */
export class MobileApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> not required
   * @param {InlineObject9} [inlineObject9]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MobileApi
   */
  public mobileUploadUrlPost(inlineObject9?: InlineObject9, options?: AxiosRequestConfig) {
    return MobileApiFp(this.configuration)
      .mobileUploadUrlPost(inlineObject9, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * NpsApi - axios parameter creator
 * @export
 */
export const NpsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    npsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/nps`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    npsPost: async (inlineObject10?: InlineObject10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/nps`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject10, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NpsApi - functional programming interface
 * @export
 */
export const NpsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NpsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async npsGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.npsGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async npsPost(
      inlineObject10?: InlineObject10,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.npsPost(inlineObject10, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * NpsApi - factory interface
 * @export
 */
export const NpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = NpsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    npsGet(options?: any): AxiosPromise<InlineResponse20013> {
      return localVarFp.npsGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject10} [inlineObject10]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    npsPost(inlineObject10?: InlineObject10, options?: any): AxiosPromise<InlineResponse20014> {
      return localVarFp.npsPost(inlineObject10, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * NpsApi - object-oriented interface
 * @export
 * @class NpsApi
 * @extends {BaseAPI}
 */
export class NpsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NpsApi
   */
  public npsGet(options?: AxiosRequestConfig) {
    return NpsApiFp(this.configuration)
      .npsGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject10} [inlineObject10]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NpsApi
   */
  public npsPost(inlineObject10?: InlineObject10, options?: AxiosRequestConfig) {
    return NpsApiFp(this.configuration)
      .npsPost(inlineObject10, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PaymentMethodApi - axios parameter creator
 * @export
 */
export const PaymentMethodApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentMethodCreatePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/paymentMethod/create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentMethodDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/paymentMethod`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentMethodSuccessPost: async (
      inlineObject11?: InlineObject11,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/paymentMethod/success`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject11, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PaymentMethodApi - functional programming interface
 * @export
 */
export const PaymentMethodApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PaymentMethodApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentMethodCreatePost(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMethodCreatePost(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentMethodDelete(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMethodDelete(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentMethodSuccessPost(
      inlineObject11?: InlineObject11,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMethodSuccessPost(inlineObject11, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * PaymentMethodApi - factory interface
 * @export
 */
export const PaymentMethodApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PaymentMethodApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentMethodCreatePost(options?: any): AxiosPromise<object> {
      return localVarFp.paymentMethodCreatePost(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentMethodDelete(options?: any): AxiosPromise<object> {
      return localVarFp.paymentMethodDelete(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject11} [inlineObject11]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentMethodSuccessPost(inlineObject11?: InlineObject11, options?: any): AxiosPromise<object> {
      return localVarFp.paymentMethodSuccessPost(inlineObject11, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * PaymentMethodApi - object-oriented interface
 * @export
 * @class PaymentMethodApi
 * @extends {BaseAPI}
 */
export class PaymentMethodApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentMethodApi
   */
  public paymentMethodCreatePost(options?: AxiosRequestConfig) {
    return PaymentMethodApiFp(this.configuration)
      .paymentMethodCreatePost(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentMethodApi
   */
  public paymentMethodDelete(options?: AxiosRequestConfig) {
    return PaymentMethodApiFp(this.configuration)
      .paymentMethodDelete(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject11} [inlineObject11]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentMethodApi
   */
  public paymentMethodSuccessPost(inlineObject11?: InlineObject11, options?: AxiosRequestConfig) {
    return PaymentMethodApiFp(this.configuration)
      .paymentMethodSuccessPost(inlineObject11, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsPaymentIdGet: async (paymentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      assertParamExists('paymentsPaymentIdGet', 'paymentId', paymentId);
      const localVarPath = `/payments/{paymentId}`.replace(`{${'paymentId'}}`, encodeURIComponent(String(paymentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentsPaymentIdGet(
      paymentId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsPaymentIdGet(paymentId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PaymentsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsPaymentIdGet(paymentId: string, options?: any): AxiosPromise<InlineResponse20015> {
      return localVarFp.paymentsPaymentIdGet(paymentId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} paymentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentsApi
   */
  public paymentsPaymentIdGet(paymentId: string, options?: AxiosRequestConfig) {
    return PaymentsApiFp(this.configuration)
      .paymentsPaymentIdGet(paymentId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsArchivedDelete: async (deleted: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'deleted' is not null or undefined
      assertParamExists('profileChatsArchivedDelete', 'deleted', deleted);
      const localVarPath = `/profile/chats/archived`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (deleted !== undefined) {
        localVarQueryParameter['deleted'] = deleted;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsArchivedPost: async (
      inlineObject12?: InlineObject12,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/profile/chats/archived`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject12, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsPinnedDelete: async (deleted: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'deleted' is not null or undefined
      assertParamExists('profileChatsPinnedDelete', 'deleted', deleted);
      const localVarPath = `/profile/chats/pinned`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (deleted !== undefined) {
        localVarQueryParameter['deleted'] = deleted;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject13} [inlineObject13]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsPinnedPost: async (
      inlineObject13?: InlineObject13,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/profile/chats/pinned`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject13, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileConfirmEmailPost: async (
      inlineObject14?: InlineObject14,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/profile/confirmEmail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject14, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Редактирование профиля <br /><br /> <b>Authentication:</b> required
     * @summary Редактирование профиля
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilePatch: async (inlineObject16?: InlineObject16, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/profile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject16, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilePushTokensDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/profile/push/tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilePushTokensPost: async (
      inlineObject15?: InlineObject15,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/profile/push/tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject15, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileChatsArchivedDelete(
      deleted: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profileChatsArchivedDelete(deleted, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileChatsArchivedPost(
      inlineObject12?: InlineObject12,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profileChatsArchivedPost(inlineObject12, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileChatsPinnedDelete(
      deleted: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profileChatsPinnedDelete(deleted, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject13} [inlineObject13]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileChatsPinnedPost(
      inlineObject13?: InlineObject13,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profileChatsPinnedPost(inlineObject13, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileConfirmEmailPost(
      inlineObject14?: InlineObject14,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profileConfirmEmailPost(inlineObject14, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * Редактирование профиля <br /><br /> <b>Authentication:</b> required
     * @summary Редактирование профиля
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profilePatch(
      inlineObject16?: InlineObject16,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profilePatch(inlineObject16, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profilePushTokensDelete(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profilePushTokensDelete(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profilePushTokensPost(
      inlineObject15?: InlineObject15,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.profilePushTokensPost(inlineObject15, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ProfileApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsArchivedDelete(deleted: number, options?: any): AxiosPromise<InlineResponse20016> {
      return localVarFp.profileChatsArchivedDelete(deleted, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject12} [inlineObject12]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsArchivedPost(inlineObject12?: InlineObject12, options?: any): AxiosPromise<InlineResponse20016> {
      return localVarFp.profileChatsArchivedPost(inlineObject12, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsPinnedDelete(deleted: number, options?: any): AxiosPromise<InlineResponse20017> {
      return localVarFp.profileChatsPinnedDelete(deleted, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject13} [inlineObject13]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileChatsPinnedPost(inlineObject13?: InlineObject13, options?: any): AxiosPromise<InlineResponse20017> {
      return localVarFp.profileChatsPinnedPost(inlineObject13, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileConfirmEmailPost(inlineObject14?: InlineObject14, options?: any): AxiosPromise<object> {
      return localVarFp.profileConfirmEmailPost(inlineObject14, options).then(request => request(axios, basePath));
    },
    /**
     * Редактирование профиля <br /><br /> <b>Authentication:</b> required
     * @summary Редактирование профиля
     * @param {InlineObject16} [inlineObject16]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilePatch(inlineObject16?: InlineObject16, options?: any): AxiosPromise<InlineResponse20018> {
      return localVarFp.profilePatch(inlineObject16, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilePushTokensDelete(options?: any): AxiosPromise<object> {
      return localVarFp.profilePushTokensDelete(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profilePushTokensPost(inlineObject15?: InlineObject15, options?: any): AxiosPromise<object> {
      return localVarFp.profilePushTokensPost(inlineObject15, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} deleted
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profileChatsArchivedDelete(deleted: number, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profileChatsArchivedDelete(deleted, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject12} [inlineObject12]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profileChatsArchivedPost(inlineObject12?: InlineObject12, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profileChatsArchivedPost(inlineObject12, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} deleted
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profileChatsPinnedDelete(deleted: number, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profileChatsPinnedDelete(deleted, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject13} [inlineObject13]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profileChatsPinnedPost(inlineObject13?: InlineObject13, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profileChatsPinnedPost(inlineObject13, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject14} [inlineObject14]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profileConfirmEmailPost(inlineObject14?: InlineObject14, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profileConfirmEmailPost(inlineObject14, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Редактирование профиля <br /><br /> <b>Authentication:</b> required
   * @summary Редактирование профиля
   * @param {InlineObject16} [inlineObject16]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profilePatch(inlineObject16?: InlineObject16, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profilePatch(inlineObject16, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profilePushTokensDelete(options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profilePushTokensDelete(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject15} [inlineObject15]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public profilePushTokensPost(inlineObject15?: InlineObject15, options?: AxiosRequestConfig) {
    return ProfileApiFp(this.configuration)
      .profilePushTokensPost(inlineObject15, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SelfplusUsersApi - axios parameter creator
 * @export
 */
export const SelfplusUsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selfplusUsersGet: async (force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/selfplusUsers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (force !== undefined) {
        localVarQueryParameter['force'] = force;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SelfplusUsersApi - functional programming interface
 * @export
 */
export const SelfplusUsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SelfplusUsersApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async selfplusUsersGet(
      force?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20019>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.selfplusUsersGet(force, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SelfplusUsersApi - factory interface
 * @export
 */
export const SelfplusUsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SelfplusUsersApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    selfplusUsersGet(force?: boolean, options?: any): AxiosPromise<Array<InlineResponse20019>> {
      return localVarFp.selfplusUsersGet(force, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * SelfplusUsersApi - object-oriented interface
 * @export
 * @class SelfplusUsersApi
 * @extends {BaseAPI}
 */
export class SelfplusUsersApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {boolean} [force]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SelfplusUsersApi
   */
  public selfplusUsersGet(force?: boolean, options?: AxiosRequestConfig) {
    return SelfplusUsersApiFp(this.configuration)
      .selfplusUsersGet(force, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SignupApi - axios parameter creator
 * @export
 */
export const SignupApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupMagicPost: async (
      inlineObject17?: InlineObject17,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/signup/magic`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject17, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SignupApi - functional programming interface
 * @export
 */
export const SignupApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SignupApiAxiosParamCreator(configuration);
  return {
    /**
     * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async signupMagicPost(
      inlineObject17?: InlineObject17,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.signupMagicPost(inlineObject17, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SignupApi - factory interface
 * @export
 */
export const SignupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SignupApiFp(configuration);
  return {
    /**
     * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
     * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
     * @param {InlineObject17} [inlineObject17]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupMagicPost(inlineObject17?: InlineObject17, options?: any): AxiosPromise<InlineResponse2001> {
      return localVarFp.signupMagicPost(inlineObject17, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * SignupApi - object-oriented interface
 * @export
 * @class SignupApi
 * @extends {BaseAPI}
 */
export class SignupApi extends BaseAPI {
  /**
   * Аутентификация/регистрация через \"магическую\" ссылку на почту <br /><br /> <b>Authentication:</b> not required
   * @summary Аутентификация/регистрация через \"магическую\" ссылку на почту
   * @param {InlineObject17} [inlineObject17]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SignupApi
   */
  public signupMagicPost(inlineObject17?: InlineObject17, options?: AxiosRequestConfig) {
    return SignupApiFp(this.configuration)
      .signupMagicPost(inlineObject17, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SpacesApi - axios parameter creator
 * @export
 */
export const SpacesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdCheckoutPost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdCheckoutPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/checkout`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdInAppPurchasePost: async (
      spaceId: number,
      inlineObject18?: InlineObject18,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdInAppPurchasePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/inAppPurchase`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject18, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdInAppSubscriptionPost: async (
      spaceId: number,
      inlineObject19?: InlineObject19,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdInAppSubscriptionPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/inAppSubscription`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject19, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdIsPurchasedPost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdIsPurchasedPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/isPurchased`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPurchasePost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdPurchasePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/purchase`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdSubscribePost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdSubscribePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/subscribe`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdSubscriptionCheckoutPost: async (
      spaceId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdSubscriptionCheckoutPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/subscription/checkout`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdSubscriptionGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdSubscriptionGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/subscription`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdUnsubscribePost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdUnsubscribePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/unsubscribe`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SpacesApi - functional programming interface
 * @export
 */
export const SpacesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SpacesApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdCheckoutPost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdCheckoutPost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdInAppPurchasePost(
      spaceId: number,
      inlineObject18?: InlineObject18,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdInAppPurchasePost(
        spaceId,
        inlineObject18,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdInAppSubscriptionPost(
      spaceId: number,
      inlineObject19?: InlineObject19,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdInAppSubscriptionPost(
        spaceId,
        inlineObject19,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdIsPurchasedPost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdIsPurchasedPost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdPurchasePost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdPurchasePost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdSubscribePost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdSubscribePost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdSubscriptionCheckoutPost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdSubscriptionCheckoutPost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdSubscriptionGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20022>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdSubscriptionGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdUnsubscribePost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdUnsubscribePost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SpacesApi - factory interface
 * @export
 */
export const SpacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SpacesApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdCheckoutPost(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdCheckoutPost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject18} [inlineObject18]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdInAppPurchasePost(
      spaceId: number,
      inlineObject18?: InlineObject18,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .spacesSpaceIdInAppPurchasePost(spaceId, inlineObject18, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdInAppSubscriptionPost(
      spaceId: number,
      inlineObject19?: InlineObject19,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .spacesSpaceIdInAppSubscriptionPost(spaceId, inlineObject19, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdIsPurchasedPost(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdIsPurchasedPost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdPurchasePost(spaceId: number, options?: any): AxiosPromise<InlineResponse20020> {
      return localVarFp.spacesSpaceIdPurchasePost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdSubscribePost(spaceId: number, options?: any): AxiosPromise<InlineResponse20021> {
      return localVarFp.spacesSpaceIdSubscribePost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdSubscriptionCheckoutPost(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp
        .spacesSpaceIdSubscriptionCheckoutPost(spaceId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdSubscriptionGet(spaceId: number, options?: any): AxiosPromise<InlineResponse20022> {
      return localVarFp.spacesSpaceIdSubscriptionGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdUnsubscribePost(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdUnsubscribePost(spaceId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * SpacesApi - object-oriented interface
 * @export
 * @class SpacesApi
 * @extends {BaseAPI}
 */
export class SpacesApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdCheckoutPost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdCheckoutPost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {InlineObject18} [inlineObject18]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdInAppPurchasePost(
    spaceId: number,
    inlineObject18?: InlineObject18,
    options?: AxiosRequestConfig,
  ) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdInAppPurchasePost(spaceId, inlineObject18, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {InlineObject19} [inlineObject19]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdInAppSubscriptionPost(
    spaceId: number,
    inlineObject19?: InlineObject19,
    options?: AxiosRequestConfig,
  ) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdInAppSubscriptionPost(spaceId, inlineObject19, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdIsPurchasedPost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdIsPurchasedPost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdPurchasePost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdPurchasePost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdSubscribePost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdSubscribePost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdSubscriptionCheckoutPost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdSubscriptionCheckoutPost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdSubscriptionGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdSubscriptionGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdUnsubscribePost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdUnsubscribePost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFilePost: async (file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/upload/file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadUrlPost: async (inlineObject21?: InlineObject21, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/upload/url`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject21, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadFilePost(
      file?: any,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20023>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFilePost(file, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadUrlPost(
      inlineObject21?: InlineObject21,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20024>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUrlPost(inlineObject21, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UploadApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadFilePost(file?: any, options?: any): AxiosPromise<InlineResponse20023> {
      return localVarFp.uploadFilePost(file, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {InlineObject21} [inlineObject21]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadUrlPost(inlineObject21?: InlineObject21, options?: any): AxiosPromise<InlineResponse20024> {
      return localVarFp.uploadUrlPost(inlineObject21, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public uploadFilePost(file?: any, options?: AxiosRequestConfig) {
    return UploadApiFp(this.configuration)
      .uploadFilePost(file, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {InlineObject21} [inlineObject21]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public uploadUrlPost(inlineObject21?: InlineObject21, options?: AxiosRequestConfig) {
    return UploadApiFp(this.configuration)
      .uploadUrlPost(inlineObject21, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * VideosApi - axios parameter creator
 * @export
 */
export const VideosApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} videoFileId
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosVideoFileIdPreviewPost: async (
      videoFileId: number,
      inlineObject22?: InlineObject22,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'videoFileId' is not null or undefined
      assertParamExists('videosVideoFileIdPreviewPost', 'videoFileId', videoFileId);
      const localVarPath = `/videos/{videoFileId}/preview`.replace(
        `{${'videoFileId'}}`,
        encodeURIComponent(String(videoFileId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject22, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VideosApi - functional programming interface
 * @export
 */
export const VideosApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VideosApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} videoFileId
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosVideoFileIdPreviewPost(
      videoFileId: number,
      inlineObject22?: InlineObject22,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.videosVideoFileIdPreviewPost(
        videoFileId,
        inlineObject22,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * VideosApi - factory interface
 * @export
 */
export const VideosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = VideosApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} videoFileId
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosVideoFileIdPreviewPost(
      videoFileId: number,
      inlineObject22?: InlineObject22,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .videosVideoFileIdPreviewPost(videoFileId, inlineObject22, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * VideosApi - object-oriented interface
 * @export
 * @class VideosApi
 * @extends {BaseAPI}
 */
export class VideosApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} videoFileId
   * @param {InlineObject22} [inlineObject22]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public videosVideoFileIdPreviewPost(
    videoFileId: number,
    inlineObject22?: InlineObject22,
    options?: AxiosRequestConfig,
  ) {
    return VideosApiFp(this.configuration)
      .videosVideoFileIdPreviewPost(videoFileId, inlineObject22, options)
      .then(request => request(this.axios, this.basePath));
  }
}
